import React from 'react';
import ReactDOM from 'react-dom';
import g11n from 'hudl-g11n';
import { data } from 'hudl-base';
import CreatePasswordPage from 'components/CreatePasswordPage';
import ErrorBoundary from 'components/shared/ErrorBoundary';

const IntlProvider = g11n.ReactIntl.IntlProvider;
const i18n = {
  locale: data.get('i18nLocale'),
  messages: data.get('i18nMessages'),
};

ReactDOM.render(
  <IntlProvider {...i18n}>
    <ErrorBoundary>
      <CreatePasswordPage />
    </ErrorBoundary>
  </IntlProvider>,
  document.getElementById('app'),
);
